import styled, { css } from 'styled-components';

/***
 * This styled component overrides the default styles of the UI Bricks input element.
 */
export const StyledInputField = styled.div`
    label {
        font-weight: 600;
        ${({ theme }) => css`
            color: ${theme.uiBricks?.defaultInputFieldTextColor || '#000'};
        `}
    }

    .input-field {
        input {
        ${({ theme }) => css`
            border-radius: ${theme.uiBricks?.inputFieldBorderRadius || '4px'};
        `}
    }
`;
